import React from "react";
import { Card, CardContent, Typography, Chip, Stack, Box } from "@mui/material";
import InsightsIcon from "@mui/icons-material/Insights";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ShieldIcon from "@mui/icons-material/Shield";

const BINANCE_YELLOW = "#F0B90B";
const CARD_BG = "#263238";
const TEXT_MUTED = "#B0BEC5";
const BORDER_COLOR = "rgba(255,255,255,0.08)";

export default function AiTradeCTA() {
  return (
    <Card
      sx={{
        bgcolor: CARD_BG,
        borderRadius: 2,
        border: `1px solid ${BORDER_COLOR}`,
        boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
        overflow: "hidden",
      }}
    >
      <CardContent sx={{ p: 2.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 800, color: "#FFFFFF", letterSpacing: 0.2 }}
          >
            AI-Powered Trading
          </Typography>
          {/* لمسة صفراء صغيرة أسفل العنوان */}
          <Box
            sx={{
              height: 3,
              width: 24,
              borderRadius: 2,
              background: `linear-gradient(90deg, ${BINANCE_YELLOW}, rgba(240,185,11,0.2))`,
            }}
          />
        </Box>

        <Typography sx={{ mb: 1.5, color: TEXT_MUTED }}>
          Leverage AI-driven insights to assist your strategies: predictive
          signals, risk guardrails, and automation hooks. Our models analyze
          multi-timeframe data to help identify momentum, volatility shifts, and
          potential reversals.
        </Typography>

        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
          <Chip
            icon={
              <InsightsIcon
                sx={{
                  color: BINANCE_YELLOW,
                  filter: "drop-shadow(0 0 3px rgba(240,185,11,0.5))",
                }}
              />
            }
            label="Predictive Signals"
            sx={{
              fontWeight: 700,
              bgcolor: "rgba(240,185,11,0.12)",
              color: BINANCE_YELLOW,
              border: `1px solid rgba(240,185,11,0.25)`,
            }}
          />

          <Chip
            icon={<ShieldIcon sx={{ color: BINANCE_YELLOW }} />}
            label="Risk Guardrails"
            variant="outlined"
            sx={{
              color: "#EAEFF2",
              borderColor: BORDER_COLOR,
              "&:hover": { borderColor: "rgba(255,255,255,0.3)" },
              "& .MuiChip-icon": {
                color: BINANCE_YELLOW,
                mr: 0.5,
              },
            }}
          />

          <Chip
            icon={<SmartToyIcon sx={{ color: BINANCE_YELLOW }} />}
            label="Automation Hooks"
            variant="outlined"
            sx={{
              color: "#EAEFF2",
              borderColor: BORDER_COLOR,
              "&:hover": { borderColor: "rgba(255,255,255,0.3)" },
              "& .MuiChip-icon": {
                color: BINANCE_YELLOW,
                mr: 0.5,
              },
            }}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
